import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

export interface IExtractedValue {
    key: string;
    default: string;
    value: string;
    sheet: string;
    cell: string;
    cannotLocate: boolean;
    important: boolean;
}

export interface IExtractionResult {
    extracted: IExtractedValue[];
}

export interface IExtractionTaskResponse {
    taskId: string;
}

interface IParams {
    organizationUuid: string;
    dealId: number;
    objectKey: string;
}

const enqueueProFormaExtraction = async ({
    organizationUuid, dealId, objectKey,
}: IParams): Promise<IExtractionTaskResponse> => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.UPLOADED_PRO_FORMAS_EXTRACT(organizationUuid, dealId),
        { objectKey },
    );
    return response.data;
};

export const useExtractProFormaValues = () => useMutation({
    mutationFn: enqueueProFormaExtraction,
});

export default useExtractProFormaValues;
